module.exports = __webpack_public_path__ + "static/img/3.be12a69.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/dishini/3.jpg
// module id = PEMX
// module chunks = 1